import React from 'react';
import { Tabs as TabsComponent } from '@multifarm/widget-components';
import s from './Tabs.module.css';
export var Tabs = function (_a) {
    var tabs = _a.tabs, value = _a.value, onChange = _a.onChange;
    return (React.createElement(TabsComponent, { className: s.tabsContainer, tabClassName: s.tabsItem, tabs: tabs, value: value, onChange: onChange }));
};
